// extracted by mini-css-extract-plugin
export default {"modal":"AddingEmployee_modal__y+O+F","buttons":"AddingEmployee_buttons__oQW+F","button":"AddingEmployee_button__muanv","input":"AddingEmployee_input__7F+cF"};